<template>
  <div>
    <div class="list__container">
      <el-table
        :data="list"
        style="width: 100%"
        class-name="table-name"
        :height="height"
        @row-click="onCheckoutItemOfUser"
      >
        <el-table-column prop="name" label="姓名" width="100">
        </el-table-column>
        <el-table-column prop="gender" label="性别" width="100">
        </el-table-column>
        <el-table-column prop="age" label="年龄" width="100"> </el-table-column>
        <el-table-column prop="address" label="楼号"> </el-table-column>
        <el-table-column prop="house_number" label="档案标签">
          <template slot-scope="{ row }">
            <div v-html="formatRiskLevel(row.riskLevel)"></div>
          </template>
        </el-table-column>
        <el-table-column
          v-if="visibleTotal"
          prop="visibleTotal"
          width="140"
          label="累计服务次数"
        >
          <template slot-scope="{ row }">
            {{ row.visitCount || 0 }} 次
          </template>
        </el-table-column>
      </el-table>
    </div>
    <DialogArchivesCard
      :id="checkUsers.sn"
      :show.sync="visible"
    ></DialogArchivesCard>
  </div>
</template>
<script>
import DialogArchivesCard from "../datav/DialogArchivesCard.vue";

export default {
  data() {
    return {
      checkUsers: {},
      visible: false,
    };
  },
  components: {
    DialogArchivesCard,
  },
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    height: {
      type: String,
      default: () => "400px",
    },
    visibleTotal: Boolean,
  },
  methods: {
    onCheckoutItemOfUser(row) {
      this.checkUsers = row;
      this.$emit("onSelect", row);
      this.visible = true;
      // this.getArchivesDetail();
      return;
    },
    formatRiskLevel(level = 0) {
      let map = new Map([
        [0, `<span style="color:#34C724;">基本健康人群</span>`],
        [1, `<span style="color:#34C724;">基本健康人群</span>`],
        [2, `<span style="color:#FF8800;">专项关爱人群</span>`],
        [3, `<span style="color:#F54A45;">重点关爱人群</span>`],
      ]);
      return map.get(level);
    },
  },
};
</script>
<style lang="less" scoped>
// .el-table,
// .el-table__body {
//   background: transparent !important;
//   color: #fff;
// }
// .el-table th {
//   background-color: transparent !important;
// }
// .el-table tr {
//   background-color: transparent !important;
// }
// .el-table__body tr.hover-row > td {
//   background-color: #a5ccf2 !important;
// }
.el-table tbody tr:hover > td {
  background-color: #17468d !important //修改成自己想要的颜色即可;;
}
</style>
